module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-care__period"
  }, [_c('control', {
    attrs: {
      "no-flex-margin": true,
      "label": 'Period ' + Number(_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    ref: "periodStart",
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": function($event) {
        return _vm.updateTotal()
      }
    },
    model: {
      value: (_vm.period.periodStart),
      callback: function($$v) {
        _vm.$set(_vm.period, "periodStart", $$v)
      },
      expression: "period.periodStart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.includeFirstDay),
      expression: "period.includeFirstDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.period.includeFirstDay) ? _vm._i(_vm.period.includeFirstDay, null) > -1 : (_vm.period.includeFirstDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.period.includeFirstDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.period, "includeFirstDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.period, "includeFirstDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.period, "includeFirstDay", $$c)
        }
      }, _vm.updateTotal]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include first day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodStartDateRules
    }
  }, [_vm._v("\n                    The Period Start Date is required and must be in the format DD/MM/YYYY\n                    and can not be after the Period End Date\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    ref: "periodEnd",
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.updateTotal
    },
    model: {
      value: (_vm.period.periodEnd),
      callback: function($$v) {
        _vm.$set(_vm.period, "periodEnd", $$v)
      },
      expression: "period.periodEnd"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.includeLastDay),
      expression: "period.includeLastDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.period.includeLastDay) ? _vm._i(_vm.period.includeLastDay, null) > -1 : (_vm.period.includeLastDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.period.includeLastDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.period, "includeLastDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.period, "includeLastDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.period, "includeLastDay", $$c)
        }
      }, _vm.updateTotal]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include last day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEndDateRules
    }
  }, [_vm._v("\n                    The Period End Date is required and must be in the format DD/MM/YYYY\n                    and can not be before the Period Start Date\n                ")])], 1)]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.overlapsAnother
    }
  }, [_vm._v("\n            This period overlaps another.\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.period.hoursPerDay),
      expression: "period.hoursPerDay"
    }],
    attrs: {
      "name": "hours_per_day"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "hoursPerDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, _vm._l((24), function(hour) {
    return _c('option', {
      domProps: {
        "value": hour
      }
    }, [_vm._v("\n                " + _vm._s(hour) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.rate),
      expression: "period.rate"
    }],
    ref: "rates",
    attrs: {
      "id": "method1",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "rate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])]), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-top-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.gratuitousCare),
      expression: "period.gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.period.gratuitousCare) ? _vm._i(_vm.period.gratuitousCare, null) > -1 : (_vm.period.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.period.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.period, "gratuitousCare", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.period, "gratuitousCare", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.period, "gratuitousCare", $$c)
        }
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Gratuitous Care Discount")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.period.total, '')
    }
  })]), _vm._v(" "), _c('control', [_c('button', {
    staticClass: "a-button a-button--smaller",
    class: _vm.index === 0 ? 'disabled' : '',
    attrs: {
      "disabled": _vm.index === 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteThisPeriod()
      }
    }
  }, [_vm._v("\n            Delete Care Period\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01ac4349!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/components/CarePeriod.vue
// module id = 1556
// module chunks = 0